export default __webpack_public_path__ + "static/media/icn_redo.1068a694.svg";